// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3G6t1","name":"styles_name__1IFL4","phone":"styles_phone__tprFo"};